import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlDocumentDTO, StihlDocumentOrganizationDTO, _TreeViewModel } from '../models/stihl-document-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { Select2Data } from 'ng-select2-component';
import { LastUpdatesModelDTO } from '../models/lastupdates';

@Injectable({
  providedIn: 'root'
})

export class DocumentService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlDocument/";
  listDownloads = new Subject<LastUpdatesModelDTO>();
  changeOpenTabViewDownload = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlDocumentDTO> {
    return this.http.get<StihlDocumentDTO>(this.pathAPI + this.controller + id);
  }

  public searchData(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getOrganizationChildren(id: string): Observable<StihlDocumentOrganizationDTO[]> {
    if (id === undefined || id === null) {
      return this.http.get<StihlDocumentOrganizationDTO[]>(this.pathAPI + this.controller + 'GetOrganizationChildren/');
    }
    else {
      return this.http.get<StihlDocumentOrganizationDTO[]>(this.pathAPI + this.controller + 'GetOrganizationChildren/' + id);
    }
  }

  public getDataClientCards(idOrganization: string, year: number, month: number): Observable<StihlDocumentDTO[]> {
    return this.http.get<StihlDocumentDTO[]>(this.pathAPI + this.controller + 'GetDataClientCards/' + idOrganization + '/' + year + '/' + month);
  }

  public createOrganization(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'CreateOrganization', data);
  }

  public updateOrganization(id: number, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateOrganization/' + id, data);
  }

  public getOrganization(id: number): Observable<StihlDocumentOrganizationDTO> {
    return this.http.get<StihlDocumentOrganizationDTO>(this.pathAPI + this.controller + 'GetOrganization/' + id);
  }

  public changeOrganizationOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getOrganizationDesc(id: string): Observable<any> {
    let options = { responseType: 'text' as 'text' };
    return this.http.get(this.pathAPI + this.controller + 'GetOrganizationDesc/' + id, options);
  }

  public deleteOrganization(idOrganization: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteOrganization/' + idOrganization);
  }

  public getOrganizationParent(id?: string): Observable<any> {
    if (id !== undefined && id !== null) {
      return this.http.get<any>(this.pathAPI + this.controller + 'GetOrganizationParent/' + id);
    }
    return null;
  }

  public getDocumentFileProgress(idDocument: string): Observable<HttpEvent<any>> {
    let endpoint = this.pathAPI + this.controller + 'GetDocumentFileProgressBar/' + idDocument;
    return this.http.post(endpoint, null, {
      responseType: "blob", reportProgress: true, observe: "events", headers: new HttpHeaders(
        { 'Content-Type': 'application/json' },
      )
    });
  }

  public saveDocumentFiles(fileImage: File): Observable<any> {
    let formData: FormData = new FormData();
    if (fileImage != undefined) {
      formData.append('fileImage', fileImage, fileImage.name);
    }
    return this.http.post<any>(this.pathAPI + this.controller + 'SaveDocumentFiles', formData);
  }

  public post(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + 'StihlDocument', data);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public getTreeViewHierarchy(): Observable<_TreeViewModel[]> {
    return this.http.get<_TreeViewModel[]>(this.pathAPI + this.controller + 'GetTreeViewHierarchy/');
  }

  public getTreeViewHierarchyOrder(id: number): Observable<_TreeViewModel[]> {
    return this.http.get<_TreeViewModel[]>(this.pathAPI + this.controller + 'GetTreeViewHierarchyOrder/' + id);
  }

  /*VISTA CONCESIONARIO*/

  public GetDocumentYear(id: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDocumentClientYear/' + id);
  }

  public GetDocumentMonth(id: string, year: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDocumentClientMonth/' + id + '/' + year);
  }

  public GetDocumentOrganization(id: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDocumentClientOrganization/' + id);
  }

  public GetOrganizationFilter(id: string): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'GetOrganizationFilter/' + id);
  }

  public searchDataClient(data: any, idOrganization: string, year: number, month: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableClient/' + idOrganization + '/' + year + '/' + month, data);
  }







}
